import React, {useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {toast} from 'react-toastify';

import {ReactComponent as ArrowRightIcon} from '../assets/svg/keyboardArrowRightIcon.svg'
import visibilityIcon from '../assets/svg/visibilityIcon.svg';

import {getAuth,  updateProfile, createUserWithEmailAndPassword} from 'firebase/auth'

import {db} from '../firebase.config'
import { serverTimestamp, setDoc, doc } from 'firebase/firestore';
import { OAuth } from '../components/OAuth';


export const SignUp = () => {

    const [showPassword, setShowPassword] = useState(false);

    const [formData, setFormData] = useState({
        name: '',
        email: "",
        password: ''
    })

    const {name , email, password} = formData;
    const navigate = useNavigate;


    const onChange= (e)=> {
        setFormData( (prevState)=> ({
            ...prevState,
            [e.target.id]: e.target.value
        }))
    }
    const onSubmit = async(e)=> {

      e.preventDefault();

      try{
        const auth= getAuth()

        const userCredential = await createUserWithEmailAndPassword(auth, email, password)

        const user= userCredential.user

        updateProfile(auth.currentUser, {
          displayName: name
        })

        const formDatacopy = {...formData}
        
        delete formDatacopy.password
        formDatacopy.timestamp= serverTimestamp();

        await setDoc(doc (db, 'users', user.uid), formDatacopy)

        navigate('/');
      } catch(error) {
        console.log(error)

        toast.error('Bad User Credentials');

      }
    }


  return (
    <>
        <div className='pageContainer'>
            <header >
                <p className='pageHeader'> Welcome Back!</p>
            </header>


            <form onSubmit={onSubmit}>
              
                <input 
                    type="text"
                    className='nameInput'
                    placeholder='Name'
                    id='name'
                    value={name}
                    onChange={onChange}
                />
                <input 
                    type="email"
                    className='emailInput'
                    placeholder='Email'
                    id='email'
                    value={email}
                    onChange={onChange}
                />

                <div className='passwordInputDiv'>
                    <input 
                        type={showPassword ? 'text': 'password'}
                        className='passwordInput'
                        placeholder='password'
                        id='password'
                        value={password}
                        onChange={onChange}
                    />

                    <img
                        src={visibilityIcon}
                        alt='show password'
                        className='showPassword'
                        onClick={ ()=> setShowPassword( (prevState)=> !prevState ) }
                    
                    />


                </div>

                <Link to='/forgot-password' className='forgotPasswordLink' >
                    Forgot Password
                </Link>

                <div className='signUpBar'>
                    <p className='signUpText'>
                        Sign Up
                    </p>
                    <button className='signUpButton'>
                        <ArrowRightIcon fill='#ffffff' width='34px' height = '34px' />
                    </button>
                </div>

            </form>

            <OAuth />

            <Link to='/sign-in' className='registerLink' >
                Sign In Instead
            </Link>
        </div>


    </>
  )
}
